import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";

const PrintOptionAttributeComments: FunctionComponent = observer(function PrintOptionAttributeComments(props) {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		options: {
			printComments,
		},
		setPrintComments,
	} = optionsStore; 

	return (
		<>
			{isDefined(printComments) && (
				<CheckboxOption
					label="CustomViewIncludeAttributeComments"
					onChange={setPrintComments}
					optionValue={printComments}
					paddingLeft={0}
				/>
			)}
		</>
	);
});

export default PrintOptionAttributeComments;